module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/glyphicons-halflings-regular.woff
// module id = 4+Es
// module chunks = 0